import React from 'react'
import './Spinner.css';

const Spinner = ()=>(
    <div className="Loader">Loading...</div>
);

export default Spinner;